// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.number-icon {
    width: 5.5rem;
    cursor: pointer;
}

.number-icon-short {
    width: 4rem;
    cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/pages/SelectSDGsNum.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB","sourcesContent":[".number-icon {\r\n    width: 5.5rem;\r\n    cursor: pointer;\r\n}\r\n\r\n.number-icon-short {\r\n    width: 4rem;\r\n    cursor: pointer;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
